import {
    CoreDI,
    CurrencyFormatter,
    LanguageService,
    ObjectBuilder,
    ResourceLoader,
    ScreenManager,
    inject,
    DisplayObjectUtils,
} from '@gongxigames/framework/core';
import {DI} from '@gongxigames/framework/slot/configs/DI';
import {GameConfig} from '@gongxigames/framework/slot/types';
import {TemplateUtils} from '@gongxigames/framework/slot/services/TemplateUtils';
import {SlotModuleV2} from '@gongxigames/framework/slotV2/baseClasses/slotModuleV2/SlotModuleV2';
import {GameOnlyEventMap} from '@gongxigames/framework/slotV2/globals';
import {ResourceManager, SlotSettings} from '@gongxigames/framework/slot';

export abstract class InfoModule<T extends GameOnlyEventMap> extends SlotModuleV2<T> {
    public static readonly NAME: symbol = Symbol('InfoModule');

    @inject(CoreDI.ResourceLoader)
    protected _loader!: ResourceLoader;

    @inject(CoreDI.DisplayObjectUtils)
    protected _displayObjectUtils!: DisplayObjectUtils;

    @inject(CoreDI.ObjectBuilder)
    protected _objectBuilder!: ObjectBuilder;

    @inject(CoreDI.CurrencyFormatter)
    protected _currencyFormatter!: CurrencyFormatter;

    @inject(DI.TemplateUtils)
    protected _templateUtils!: TemplateUtils;

    @inject(CoreDI.LanguageService)
    protected _languageService!: LanguageService;

    @inject(CoreDI.GameConfig)
    protected _gameConfig!: GameConfig;

    @inject(CoreDI.ScreenManager)
    protected _screenManager!: ScreenManager;

    @inject(DI.ResourceManager)
    protected _resourceManager!: ResourceManager;

    @inject(CoreDI.Settings)
    protected _settings!: SlotSettings;
}
